let moment = require('moment');

const calculateminutesbetweentwoDates = function (endDate, startDate) {
  let time_start = new Date(startDate).getTime();
  let time_end = new Date(endDate).getTime();

  let hour_diff = time_end - time_start; //in ms
  let sec_diff = hour_diff / 1000; //in s
  let min_diff = Math.round(hour_diff / 60 / 1000); //in minutes

  return min_diff;
};

const convertToImageRename = function (dateString) {
  return moment(
    dateString,
    'ddd MMM DD YYYY HH:mm:ss GMT+XXXX (Timezone Name)'
  ).format('DDMMYYYYHHmmss');
};

const convertDateToGMT = function (dateString) {
  return moment(
    dateString,
    'ddd MMM DD YYYY HH:mm:ss GMT+XXXX (Timezone Name)'
  ).format('YYYY-MM-DDTHH:mm:ss.SSSZ([GMT])');
};

const convertStringToDate = function (dateString) {
  const dateObj = moment(dateString, 'DD-MM-YYYY').format('DD-MM-YYYY');
  return dateObj;
};

const ontToOneFormat = function (dateString, formatOne, formatTwo) {
  return moment(dateString, formatOne).format(formatTwo);
};

const convertStringToYYYYMMDD = function (dateString) {
  const dateObj = moment(dateString).format('YYYY-MM-DD');
  return dateObj;
};

const convertDDMMYYYYToYYYYMMDD = function (dateString) {
  return moment(dateString, 'DD-MM-YYYY').format('YYYY-MM-DD');
};

const convertYYYYMMDDToDDMMYYYY = function (dateString) {
  return moment(dateString, 'YYYY-MM-DD').format('DD-MM-YYYY');
};

const formatTo = function (date, format) {
  return moment(date).format(format);
};

const convertToHHMM = function (timeString) {
  return moment(timeString, 'HH:mm:ss').format('HH:mm');
};

const format_date_yy_mm_dd = function (date) {
  date = new Date(date);
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let dt = date.getDate();

  if (dt < 10) {
    dt = '0' + dt;
  }
  if (month < 10) {
    month = '0' + month;
  }
  return year + '-' + month + '-' + dt;
};

const parseDate = function (str) {
  var mdy = str.split('-');
  return `${mdy[2]}-${mdy[1]}-${mdy[0]}`;
};

/**
 * @description:get date time based on domain name
 * @author:Anil.ch
 * @date:29-06-2021
 * @param {*} date
 * @param {*} domain_name
 * @returns
 */
const getTimeZoneDate = function (date, domain_name) {
  let timeZone = 'Asia/Qatar';
  if (domain_name == 'QA') {
    timeZone = 'Asia/Qatar';
  }
  let datetimestr = new Date(date.toUTCString()).toLocaleString('en-US', {
    timeZone: timeZone,
  });
  return moment(datetimestr, 'MM/DD/YYYY, HH:mm:ss a').format(
    'YYYY-MM-DD HH:mm:ss'
  );
};

const currentDateFormat = function (format) {
  return moment().format('YYYY-MM-DDTHH-mm-ss');
};

const convertToLetterDate = function (dateString) {
  return moment(dateString, 'DD-MM-YYYY').format('ddd, DD MMM, YYYY');
};

const convertDateToLetterDate = function (dateString) {
  return moment(dateString).format('ddd, DD MMM, YYYY');
};

const convertToLetterDateYYYY = function (dateString) {
  return moment(dateString, 'YYYY-MM-DD').format('ddd, DD MMM, YYYY');
};

const convertToLetterDateTime = function (dateString) {
  return moment(dateString, 'DD-MM-YYYY HH:mm:ss').format(
    "ddd, DD MMM 'YY, H:mm"
  );
};

const convertToLetterDate24TimeFormat = function (dateString) {
  return moment(dateString).format("ddd, DD MMM 'YY, HH:mm");
};

const convertTimeToMin = function (dateString) {
  return moment.duration(dateString).asMinutes();
};

const convertISTtimeZone = function (dateString) {
  return moment(dateString, 'DD-MM-YYYY').format(
    'ddd MMM DD YYYY HH:mm:ss [GMT+0530 (IST)]'
  );
};

const isTimeAfter = function (one, two) {
  var oneConverted = moment(one, 'YYYY-MM-DD HH:mm');
  var twoConverted = moment(two, 'YYYY-MM-DD HH:mm');
  var result = oneConverted.isAfter(twoConverted);
  return result;
};

const enumerateDaysBetweenDates = function (stdt, enddt) {
  var startDate = moment(stdt);
  var endDate = moment(enddt);

  var now = startDate.clone(),
    dates = [];
  while (now.isSameOrBefore(endDate)) {
    dates.push(now.format('YYYY-MM-DD'));
    now.add(1, 'days');
  }
  return dates;
};

const addYearsToDate = function (years, dateObj) {
  const convertDate = moment(dateObj, 'DD-MM-YYYY');
  const convertedDate = convertDate.subtract(years, 'Y');
  return convertedDate;
};

const convertToDDMMYYYYHHMMSS = function (dateString) {
  return moment(dateString, 'YYYY-MM-DD HH:mm:ss').format(
    'DD-MM-YYYY HH:mm:ss'
  );
};

const convertLetterToDate = function (dateString) {
  return moment(dateString, 'DD-MM-YYYY').format('ddd, DD MMM YYYY');
};
const convertTimeToYYYYMMDD = function (dateString) {
  const dateObj = moment(dateString, 'DD-MM-YYYY HH:mm:ss').format(
    'YYYY-MM-DD'
  );
  return dateObj;
};
const convertDateToYYYYMMDD = function (dateString) {
  const dateObj = moment(dateString).format('YYYY/MM/DD');
  return dateObj;
};
const convertToDDMMWithoutSpace = function (dateString) {
  return moment(dateString, 'DD-MM').format('DD MMM');
};
const convertToDDMM = function (dateString) {
  return moment(dateString, 'DD-MM').format(' DD MMM');
};

const convertToShortMonth = function (dateString) {
  const dateObj = moment(dateString).format('MMM');
  return dateObj;
};

const convertToOnlydate = function (dateString) {
  const dateObj = moment(dateString).format('Do');
  return dateObj;
};

const convertToOnlyYear = function (dateString) {
  const dateObj = moment(dateString).format('YY');
  return dateObj;
};

const convertYYYYMMDDToDDMMYY = function (dateString) {
  return moment(dateString, 'YYYY-MM-DD').format('ddd, DD MMM, YYYY');
};

const dateTimeFormat = function (dateString) {
  return moment(
    dateString,
    'ddd MMM DD YYYY HH:mm:ss GMT+XXXX (Timezone Name)'
  ).format('YYYY-MM-DD HH:mm:ss');
};

const convertStringToDDMMYYYY = function (dateString) {
  const dateObj = moment(dateString).format('DD-MM-YYYY');
  return dateObj;
};
const convertDateToDDMMMYYY = function (dateString) {
  const dateObj = moment(dateString).format('DD MMM YYYY');
  return dateObj;
};

// Default export containing all date format functions
const DateFormats = {
  calculateminutesbetweentwoDates,
  convertStringToDate,
  parseDate,
  convertStringToYYYYMMDD,
  getTimeZoneDate,
  currentDateFormat,
  convertToLetterDate,
  convertDateToLetterDate,
  convertTimeToMin,
  convertTimeToYYYYMMDD,
  convertDateToYYYYMMDD,
  isTimeAfter,
  enumerateDaysBetweenDates,
  formatTo,
  addYearsToDate,
  convertToLetterDateYYYY,
  convertToLetterDateTime,
  convertDDMMYYYYToYYYYMMDD,
  ontToOneFormat,
  convertToImageRename,
  convertISTtimeZone,
  convertToDDMMYYYYHHMMSS,
  convertLetterToDate,
  convertDateToGMT,
  convertToLetterDate24TimeFormat,
  convertToHHMM,
  convertYYYYMMDDToDDMMYYYY,
  format_date_yy_mm_dd,
  convertToDDMMWithoutSpace,
  convertToDDMM,
  convertDateToDDMMMYYY,
  convertToShortMonth,
  convertToOnlydate,
  convertToOnlyYear,
  convertYYYYMMDDToDDMMYY,
  dateTimeFormat,
  convertStringToDDMMYYYY,
};

export default DateFormats;

// Named exports for individual functions
export {
  calculateminutesbetweentwoDates,
  convertStringToDate,
  parseDate,
  convertStringToYYYYMMDD,
  convertDateToYYYYMMDD,
  getTimeZoneDate,
  currentDateFormat,
  convertToLetterDate,
  convertTimeToMin,
  isTimeAfter,
  enumerateDaysBetweenDates,
  formatTo,
  addYearsToDate,
  convertDDMMYYYYToYYYYMMDD,
  ontToOneFormat,
  convertToDDMM,
  convertToShortMonth,
  convertToOnlydate,
  convertToOnlyYear,
  dateTimeFormat,
  convertLetterToDate,
  convertToLetterDateTime,
  convertToImageRename,
  convertISTtimeZone,
  convertTimeToYYYYMMDD,
  convertStringToDDMMYYYY,
  convertDateToDDMMMYYY,
  convertYYYYMMDDToDDMMYY,
  convertToDDMMWithoutSpace,
  format_date_yy_mm_dd,
  convertDateToLetterDate,
  convertToLetterDateYYYY,
  convertToLetterDate24TimeFormat,
  convertToDDMMYYYYHHMMSS,
  convertDateToGMT,
  convertToHHMM,
  convertYYYYMMDDToDDMMYYYY,
};
